import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TeamStore as MobxTeamStore } from 'nomst/Stores/team.store';
import { configurationsStore, navigateToNoMst } from 'utils/MobxDataManager/singletons';
import './teamProgressSummaryNotReadyView.scss';

export interface ITeamProgressSummaryNotReadyViewProps {
    store: MobxTeamStore;
}

export class TeamProgressSummaryNotReadyView extends
    React.Component<ITeamProgressSummaryNotReadyViewProps> {
    constructor(props: ITeamProgressSummaryNotReadyViewProps) {
        super(props);
        this.goToCycleConfig = this.goToCycleConfig.bind(this);
        this.goToCeoTeamView = this.goToCeoTeamView.bind(this);
    }

    render(): React.ReactNode {
        return (
            <div className="nomst-cycle-not-ready">
                <img alt=""
                    src={require('contents/icon-team_review_colored.svg')}
                    className="nomst-cycle-not-ready__pending-cycle-icon"
                />
                {this.renderContent()}
            </div>
        );
    }

    renderContent(): React.ReactNode  {
        const { store } = this.props;
        const isOnlyManager = store.user.isRoleOnlyManager;
        const cycleConfiguration = configurationsStore.currentConvertedConfiguration;

        // manager user, no cycle, or cycle is not open
        if (isOnlyManager && (!cycleConfiguration.cycleId || !cycleConfiguration.isOpen)) {
            return this.renderManagerUserCycleUnopened();
        }

        // not manager user, no cycle exists or cycle is closed/closing
        if (!isOnlyManager &&
            (!cycleConfiguration.cycleId ||
                cycleConfiguration.isClosed ||
                cycleConfiguration.isClosing ||
                cycleConfiguration.isPublished)) {
            return this.renderNotManagerUserNoCycle();
        }

        // not manager user, cycle exists but is not yet open
        if (!isOnlyManager && cycleConfiguration.cycleId && cycleConfiguration.isCurrentlyPending) {
            return this.renderNotManagerUserCycleUnopened();
        }

        return null;
    }

    renderManagerUserCycleUnopened(): React.ReactNode  {
        return (
            <div className="nomst-cycle-not-ready__content nomst-cycle-not-ready__content--manager-view">
                <h2 className="nomst-cycle-not-ready__headline">
                    It&apos;s almost time to make pay decisions
                </h2>
                <p className="nomst-cycle-not-ready__paragraph">
                    Your HR team is busy setting up the next cycle.
                    You will be notified by email when your team is ready.
                </p>
            </div>
        );
    }

    renderNotManagerUserNoCycle(): React.ReactNode  {
        return (
            <div className="nomst-cycle-not-ready__content nomst-cycle-not-ready__content--no-cycle">
                <h2 className="nomst-cycle-not-ready__headline">
                    No future cycles configured
                </h2>
                <p className="nomst-cycle-not-ready__paragraph">
                    To get started, create a new cycle.
                    Once your cycle is configured and open, you can notifiy managers by email.
                </p>
                <div className="nomst-cycle-not-ready__actions">
                    <button
                        className="pxl-btn nomst-cycle-not-ready__review-settings-button pxl-btn--primary"
                        onClick={this.goToCycleConfig}
                    >
                        Create a Cycle
                    </button>
                    {configurationsStore.currentCycleId > 0 &&
                    (
                        <button
                            className="nomst-cycle-not-ready__review-team-button pxl-link"
                            onClick={this.goToCeoTeamView}
                        >
                            <i className="icon-users" />
                            Review Teams
                        </button>
                    )}
                </div>
            </div>
        );
    }

    renderNotManagerUserCycleUnopened(): React.ReactNode  {
        return (
            <div className="nomst-cycle-not-ready__content nomst-cycle-not-ready__content--not-open">
                <h2 className="nomst-cycle-not-ready__headline">
                    Your next cycle is almost ready
                </h2>
                <p className="nomst-cycle-not-ready__paragraph">
                    Before you open the cycle, review your cycle settings to ensure its ready to go.
                    Once the cycle is open, you can notify managers by email its time to make pay decisions.
                </p>
                <div className="nomst-cycle-not-ready__actions">
                    <button
                        className="pxl-btn nomst-cycle-not-ready__review-settings-button pxl-btn--primary"
                        onClick={this.goToCycleConfig}
                    >
                        Review Settings
                    </button>
                    <button
                        className="nomst-cycle-not-ready__review-team-button pxl-link"
                        onClick={this.goToCeoTeamView}
                    >
                        <i className="icon-users" />
                        Review Teams
                    </button>
                </div>
            </div>
        );
    }

    private goToCycleConfig(): void {
        navigateToNoMst.navigateToMstBudgetSettings(configurationsStore.currentCycleId);
    }

    private async goToCeoTeamView(): Promise<void> {
        const { navigationStore } = this.props.store;
        await navigationStore.goToCeoTeamView();
    }
}

export default inject('store')(observer(TeamProgressSummaryNotReadyView));